import React, { memo } from 'react'
import AppFormikInputFieldRadio from 'utlis/helpers/forms/AppFormikInputFieldRadio'

function FormPayment__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            <AppFormikInputFieldRadio
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                labelName={"Activate Bank Payment"}
                formikFieldName={"activate_bank_payment"}
            />

            <AppFormikInputFieldRadio
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                labelName={"Activate net30"}
                formikFieldName={"activate_net30"}
            />
        </React.Fragment >
    )
}

export default memo(FormPayment__Details)